module.exports = __webpack_public_path__ + "img/Serro_Ref1.66d31ecc.png";